export default __webpack_public_path__ + "media/images/book-8e7b0c19d920b3743db9674ff1cd8d40.png";